import React, { useState, useEffect } from "react";

const aboutParagraphs = [
    "Hi, I'm Venkatesan",
    "a full-time options trader with 5 years of hands-on experience in the Indian stock market.",
    "I'm 25 years old and a B.Com graduate who chose trading as a full-time career right after college. Over the years, I've specialized in Nifty options trading, mastering both option buying and option selling. What sets my approach apart is the ability to identify when to buy and when to sell — based on India VIX, market sentiment, and other technical factors.",
    "But my journey wasn't smooth. Like many aspiring traders, I struggled in the beginning. I attended multiple workshops and courses hoping to learn — but what I found was disappointing. Most of them lacked real mentorship. They were focused on selling courses, not on building real traders.",
    "That's when I decided to become the kind of mentor"
];

function AnimatedAbout({ paragraphs }) {
    const [current, setCurrent] = useState(0);
    return (
        <div className="content" style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '1rem 1.5rem',
            textAlign: 'left',
            maxWidth: '100%',
        }}>
            {paragraphs.map((text, idx) => (
                idx === 0 ? (
                    <TypewriterNameHeader
                        key={idx}
                        textBefore={"Hi, I'm "}
                        nameText="Venkatesan"
                        start={current === idx}
                        onDone={() => setCurrent(c => c + 1)}
                    />
                ) : (
                    <TypewriterParagraph
                        key={idx}
                        text={text}
                        start={current === idx}
                        onDone={() => setCurrent(c => c + 1)}
                        style={{ fontSize: '1.7rem', marginBottom: idx === paragraphs.length - 1 ? 0 : '1.5rem', color: '#444' }}
                        className={idx === 1 ? 'lead' : ''}
                    />
                )
            ))}
        </div>
    );
}

function TypewriterNameHeader({ textBefore, nameText, start, onDone }) {
    const [displayedBefore, setDisplayedBefore] = useState("");
    const [displayedName, setDisplayedName] = useState("");
    const [phase, setPhase] = useState(0); // 0: before, 1: name, 2: done
    useEffect(() => {
        if (!start) return;
        let i = 0;
        if (phase === 0) {
            const interval = setInterval(() => {
                setDisplayedBefore(textBefore.slice(0, i + 1));
                i++;
                if (i === textBefore.length) {
                    clearInterval(interval);
                    setTimeout(() => setPhase(1), 200);
                }
            }, 18);
            return () => clearInterval(interval);
        } else if (phase === 1) {
            let j = 0;
            const interval = setInterval(() => {
                setDisplayedName(nameText.slice(0, j + 1));
                j++;
                if (j === nameText.length) {
                    clearInterval(interval);
                    setTimeout(() => {
                        setPhase(2);
                        if (onDone) onDone();
                    }, 400);
                }
            }, 18);
            return () => clearInterval(interval);
        }
    }, [start, phase, textBefore, nameText, onDone]);
    return (
        <h4 className="title" style={{ fontSize: '2.3rem', marginBottom: '1rem', color: '#222', minHeight: '1.2em' }}>
            {displayedBefore}
            <span className="theme-gradient">{displayedName}</span>
        </h4>
    );
}

function TypewriterParagraph({ text, start, onDone, style, className }) {
    const [displayed, setDisplayed] = useState("");
    useEffect(() => {
        if (!start) return;
        let i = 0;
        const interval = setInterval(() => {
            setDisplayed(text.slice(0, i + 1));
            i++;
            if (i === text.length) {
                clearInterval(interval);
                if (onDone) setTimeout(onDone, 400);
            }
        }, 18);
        return () => clearInterval(interval);
    }, [start, text, onDone]);
    // Estimate a fixed height for each paragraph (adjust as needed)
    const fixedHeight = className === 'title' ? '1.2em' : '2.5em';
    const fixedWidth = '100%';
    return (
        <p
            className={className}
            style={{
                ...style,
                minHeight: fixedHeight,
                overflow: 'hidden',
                display: 'block',
                boxSizing: 'border-box',
                background: 'none', // Remove background from paragraph
                borderRadius: 0,    // Remove border radius from paragraph
                boxShadow: 'none',  // Remove shadow from paragraph
                padding: 0,         // Remove padding from paragraph
            }}
        >
            <strong>{displayed}</strong>
        </p>
    );
}

const Slider = () => {
    return (
        <div
            className="slider-area rbt-banner-6 variation-01 header-transperent-spacer"
            style={{
                backgroundColor: 'white !important',
                backgroundImage: 'none !important',
                position: 'relative',
                minHeight: '500px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {/* Overlay for readability */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(255, 255, 255, 0)',
                zIndex: 1
            }} />
            <div className="container-fluid px-2 px-md-5" style={{ position: 'relative', zIndex: 2, maxWidth: '1400px' }}>
                <div className="row align-items-center flex-column-reverse flex-md-row">
                    {/* Left: Profile Image */}
                    <div className="col-12 col-md-5 text-center mb-4 mb-md-0 d-flex flex-column align-items-center">
                        <div className="rbt-shadow-box" style={{ width: '80%', maxWidth: '340px', marginBottom: '1.5rem', padding: 0 }}>
                            <img
                                className="img-fluid"
                                src="assets1/images/about/about-12.jpg"
                                alt="Profile"
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                    {/* Right: Original Text content */}
                    <div className="col-12 col-md-7 d-flex flex-column align-items-center align-items-md-start">
                        <div className="inner text-md-start text-center w-100">
                            <div className="badge-top mb--55">
                                <span className="rbt-badge">Trade with Tactics, Not Luck.</span>
                            </div>
                            <h1 className="title" style={{ color: 'black' }}>
                                Real-time market support. <span className="theme-gradient" style={{ color: 'black' }}>Proven Nifty options strategies</span>
                            </h1>
                            <p className="subtitle mt--20" style={{ color: 'black' }}>
                                Built by a trader, for traders.
                            </p>
                            <div className="button-group mt--30">
                                <a className="rbt-btn btn-gradient rbt-marquee-btn" href="#courses">
                                    <span data-text="Explore Our Mentorship Program">Explore Our Mentorship Program</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Animated About Section below the main row */}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '100%' }}>
                        <AnimatedAbout paragraphs={aboutParagraphs} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(Slider);
